// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Search-Icon.module.scss  */
.Search-Icon-module-Root_2D8 {
  width: 40px;
  margin-top: auto;
  margin-bottom: auto;
  color: var(--search-icon-color); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Search/Icon/Search-Icon.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B,EAAE","sourcesContent":["/*  imported from Search-Icon.module.scss  */\n.Search-Icon-module-Root_2D8 {\n  width: 40px;\n  margin-top: auto;\n  margin-bottom: auto;\n  color: var(--search-icon-color); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
